import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getApprovalFlowScreen,
  saveApprovalFlow,
} from '@ebalance/proto/bffuser/v1/approval_flow_service-ApprovalFlowService_connectquery'
import { getWorkflowTemplateFormOptions } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 承認フロー設定のリセット用 mutation。
 *
 * destructive リセットは「当該業務処理の全 cells を既定値 (全エリア承認なし・
 * 段階未設定) で上書き保存し、conditions を空にする (= サーバー側で既定値の
 * 承認モード行を persisted saved として確定する)」 ことで実現する
 * (AC-APF-012a、既定値は converter.ts の buildDefaultCells が SoT)。
 * 保存成功後は `getApprovalFlowScreen` を invalidate し、 最新の saved 状態を
 * 再取得・再初期化する。workflow-template-form-options-bff-aggregation
 * design: テンプレート editor の集約 query (`getWorkflowTemplateFormOptions`)
 * の approval_processes 投影も同じ backend 設定を投影するため invalidate する。
 */
export function useResetApprovalFlow(): InvalidatingMutationResultFor<
  typeof saveApprovalFlow
> {
  return useInvalidatingMutation(saveApprovalFlow, [
    createConnectQueryKey({
      schema: getApprovalFlowScreen,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getWorkflowTemplateFormOptions,
      cardinality: 'finite',
    }),
  ])
}
